import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  checkArray,
  checkNull,
  changeDateFormat,
} from "../../../../../../helpers";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  changeSettingValue,
  getMasterSetting,
  refreshChannelsMasterSetting,
  saveChannelsMasterSetting,
  updateChannelsMasterSetting,
  updateChannelsMasterSettingStatus,
} from "../../../../../../Redux/actions";
import ModelContainer from "../../../../../Components/ModelContainer";
import ErrorContainer from "../../../../../Components/ErrorContainer";

const channelsMasterSettingSchema = yup.object({
  id: yup.string().nullable(),
  channel_id: yup.string().required(),
  accounts: yup.array().nullable(),
});
const editChannelsMasterSettingSchema = yup.object({
  master_id: yup.string().required(),
  channel_id: yup.string().required(),
  merchant_id: yup.string().required(),
  cluster_id: yup.string().required(),
  store_merchant_id: yup.string().required(),
});

const Channels = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    master_setting_details,
    channelsMasterSettingModal,
    is_channelsMasterSetting_loading,
    editChannelsMasterSettingModal,
    is_editChannelsMasterSetting_loading,
  } = useSelector((state) => state.settingReducer);

  useEffect(() => {
    dispatch(getMasterSetting());

    return () => {
      dispatch(changeSettingValue("master_setting_details", null));
    };
  }, []);

  /* ChannelsMasterSettings */
  const initialchannelsMasterSettingForm = {
    id: "",
    channel_id: "",
    accounts: [],
  };
  const {
    register: channelsMasterSettingReg,
    formState: { errors: channelsMasterSettingErrors },
    handleSubmit: channelsMasterSettingSubmit,
    setValue: channelsMasterSettingSetValue,
    reset: channelsMasterSettingReset,
  } = useForm({
    resolver: yupResolver(channelsMasterSettingSchema),
    defaultValues: initialchannelsMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [channelsMasterSettingInputForm, setChannelsMasterSettingInputForm] =
    useState(initialchannelsMasterSettingForm);

  const [accounts, setAccounts] = useState([]);

  const changeChannelsMasterSettingInputHandler = (input, val) => {
    channelsMasterSettingSetValue(input, val);
    setChannelsMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialChannelsMasterSettingModalState = (
    initailVal = initialchannelsMasterSettingForm
  ) => {
    setChannelsMasterSettingInputForm(initailVal);
    channelsMasterSettingReset(initailVal);
  };
  const closeChannelsMasterSettingModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("channelsMasterSettingModal", value));
      initialChannelsMasterSettingModalState();
    },
    [channelsMasterSettingModal]
  );
  const submitChannelsMasterSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 1;
    console.log("submitChannelsMasterSettingForm", data);
    dispatch(saveChannelsMasterSetting(data));
  };
  const submitPmMasterUpdateSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 2;
    console.log("submitPmMasterUpdateSettingForm", data);
    dispatch(saveChannelsMasterSetting(data));
  };
  const deleteChannelsMasterSettingHandler = (id) => {
    // dispatch(deleteChannelsMasterSetting({ id }));
  };

  /* Edit pm Master Setting */

  const initialeditChannelsMasterSettingForm = {
    master_id: "",
    channel_id: "",
    merchant_id: "",
    cluster_id: "",
    store_merchant_id: "",
  };
  const {
    register: editChannelsMasterSettingReg,
    formState: { errors: editChannelsMasterSettingErrors },
    handleSubmit: editChannelsMasterSettingSubmit,
    setValue: editChannelsMasterSettingSetValue,
    reset: editChannelsMasterSettingReset,
  } = useForm({
    resolver: yupResolver(editChannelsMasterSettingSchema),
    defaultValues: initialeditChannelsMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [selectedChannelSetting, setSelectedChannelSetting] = useState(null);
  const [
    editChannelsMasterSettingInputForm,
    setEditChannelsMasterSettingInputForm,
  ] = useState(initialeditChannelsMasterSettingForm);

  const changeEditChannelsMasterSettingInputHandler = (input, val) => {
    editChannelsMasterSettingSetValue(input, val);
    setEditChannelsMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialEditChannelsMasterSettingModalState = (
    initailVal = initialeditChannelsMasterSettingForm
  ) => {
    setEditChannelsMasterSettingInputForm(initailVal);
    editChannelsMasterSettingReset(initailVal);
  };
  const closeEditChannelsMasterSettingModal = useCallback(
    (value) => {
      if (!value) setSelectedChannelSetting(null);
      dispatch(changeSettingValue("editChannelsMasterSettingModal", value));
      initialEditChannelsMasterSettingModalState();
    },
    [editChannelsMasterSettingModal]
  );
  const submitEditChannelsMasterSettingForm = (data) => {
    data.setting_type = 1;
    console.log("submitEditChannelsMasterSettingForm", data);
    dispatch(updateChannelsMasterSetting(data));
  };
  const submitEditPmMasterUpdateSettingForm = (data) => {
    data.setting_type = 2;
    console.log("submitEditPmMasterUpdateSettingForm", data);
    dispatch(updateChannelsMasterSetting(data));
  };
  const deleteEditChannelsMasterSettingHandler = (id) => {
    // dispatch(deleteEditChannelsMasterSetting({ id }));
  };

  const editChannelsMasterSettingHandler = (editChannelsMasterSetting) => {
    setSelectedChannelSetting(editChannelsMasterSetting);
    closeEditChannelsMasterSettingModal(true);
    const editValues = {
      master_id: editChannelsMasterSetting?.id ?? "",
      channel_id: editChannelsMasterSetting?.channel_id ?? "",
      merchant_id: editChannelsMasterSetting?.merchant_id ?? "",
      cluster_id: editChannelsMasterSetting?.cluster_id ?? "no",
      store_merchant_id: editChannelsMasterSetting?.store_merchant_id ?? "",
    };
    initialEditChannelsMasterSettingModalState(editValues);
  };

  /* Edit pm Master Setting END */

  const updateChannelSettingStatusHandler = (id, status) => {
    dispatch(updateChannelsMasterSettingStatus({ id, status }));
  };
  const refreshChannelsMasterSettingHandler = (id) => {
    dispatch(refreshChannelsMasterSetting({ id }));
  };

  const getChannelsMasterSettingAction = (channelsMasterSetting) => {
    let res = null;
    if (channelsMasterSetting?.status == 1) {
      res = (
        <>
          {channelsMasterSetting?.setting_type == 1 ? (
            <a
              role="button"
              class="circle_icon edit_tooltip editAccountPm"
              onClick={() =>
                editChannelsMasterSettingHandler(channelsMasterSetting)
              }
            >
              <i class="iconSprites edit-icon"></i>
            </a>
          ) : (
            <a
              role="button"
              class="circle_icon refresh_tooltip refresh_setting_pm"
              onClick={() =>
                refreshChannelsMasterSettingHandler(channelsMasterSetting?.id)
              }
            >
              <i class="iconSprites refresh-icon"></i>
            </a>
          )}

          <a
            role="button"
            class="circle_icon pwr_tooltip on"
            onClick={() =>
              updateChannelSettingStatusHandler(
                channelsMasterSetting?.id,
                "inactive"
              )
            }
          >
            <i class="iconSprites pwr-icon"></i>
          </a>
        </>
      );
    } else {
      res = (
        <a
          role="button"
          class="circle_icon pwr_tooltip"
          onClick={() =>
            updateChannelSettingStatusHandler(
              channelsMasterSetting?.id,
              "active"
            )
          }
        >
          <i class="iconSprites pwr-icon"></i>
        </a>
      );
    }
    return res;
  };

  const checkAccountIsClicked = (account) => {
    let res = true;

    if (
      checkArray(accounts) &&
      checkArray(account?.cluster) &&
      checkArray(account?.cluster.filter((p) => checkArray(p.stores)))
    ) {
      let accountIds = [];
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              accountIds.push(store.merchant_id);
            });
          }
        });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return accountIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const checkClusterIsClicked = (cluster) => {
    let res = true;
    if (checkArray(accounts) && checkArray(cluster?.stores)) {
      let clusterIds = [];
      cluster?.stores.map((store) => {
        clusterIds.push(store.merchant_id);
      });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return clusterIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const otherAccountClickHandler = (other_account) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == other_account?.id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != other_account?.id
      );
    } else {
      newAccounts.push({
        merchant_id: other_account?.parent_merchant_id,
        cluster_id: other_account?.id,
        store_merchant_id: other_account?.id,
      });
    }
    setAccounts(newAccounts);
  };
  const accountClickHandler = (account) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.merchant_id != account?.id);
    const checkIsClicked = checkAccountIsClicked(account);
    if (checkArray(account?.cluster) && !checkIsClicked) {
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              newAccounts.push({
                merchant_id: account?.id,
                cluster_id: store?.cluster_id,
                store_merchant_id: store?.merchant_id,
              });
            });
          }
        });
    }
    setAccounts(newAccounts);
  };

  const clusterClickHandler = (merchantId, cluster) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.cluster_id != cluster?.id);
    const checkIsClicked = checkClusterIsClicked(cluster);
    if (checkArray(cluster?.stores) && !checkIsClicked) {
      cluster?.stores.map((store) => {
        newAccounts.push({
          merchant_id: merchantId,
          cluster_id: store?.cluster_id,
          store_merchant_id: store?.merchant_id,
        });
      });
    }
    setAccounts(newAccounts);
  };

  const storeClickHandler = (merchantId, store) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == store?.merchant_id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != store?.merchant_id
      );
    } else {
      newAccounts.push({
        merchant_id: merchantId,
        cluster_id: store?.cluster_id,
        store_merchant_id: store?.merchant_id,
      });
    }
    setAccounts(newAccounts);
  };

  const msetingArr = {
    1: "Master & Lock",
    2: "Push & Forgot",
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id="paymentMethodMasterSettings">
        <button
          className="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseOne"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseOne"
        >
          <div className="col d-flex align-items-center">
            <h4 className="event-alert p-0 mb-0">
              Channels Type Master Settings
            </h4>
          </div>{" "}
        </button>
      </h2>
      <div
        id="panelsStayOpen-collapseOne"
        className="accordion-collapse collapse show"
        aria-labelledby="paymentMethodMasterSettings"
      >
        <div className="">
          <div className="row mx-0">
            <div className="container px-0">
              <div className="shadowclass mt-0">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th className="col-2">Channels Type</th>
                        <th className="col-2">Cluster Name</th>
                        <th>Account Name</th>
                        <th>Master Setting</th>
                        <th>Last Push Date</th>
                        <th>Status</th>
                        <th className="action-td">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(
                        master_setting_details?.channels?.master_settings
                      ) &&
                        master_setting_details?.channels?.master_settings.map(
                          (setting) => {
                            return (
                              <tr>
                                <td>{setting?.channel?.channel_name ?? ""}</td>
                                <td>
                                  {setting?.cluster?.cluster_name
                                    ? setting?.cluster?.cluster_name
                                    : "Orphan - No Cluster"}
                                </td>
                                <td>{setting?.store_merchant?.account_name}</td>
                                <td>{msetingArr?.[setting?.setting_type]}</td>
                                <td>
                                  {changeDateFormat(
                                    setting?.push_date,
                                    "MMMM DD, yyyy"
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {setting?.status == 1 ? (
                                    <span class="green_tag"> Active </span>
                                  ) : (
                                    <span class="bordered_tag"> Inactive </span>
                                  )}
                                </td>
                                <td>
                                  <div className="d-flex justify-content-center">
                                    {getChannelsMasterSettingAction(setting)}{" "}
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
                  <div className="my-3">
                    <button
                      className="btn green-btn-revert add-plus"
                      id="addCount"
                      type="button"
                      onClick={() => closeChannelsMasterSettingModal(true)}
                    >
                      <i className="i-icon"> </i> Add Account Channel
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`ADD CHANNEL`}
        open={channelsMasterSettingModal}
        closeModal={closeChannelsMasterSettingModal}
        submitModal={channelsMasterSettingSubmit(
          submitChannelsMasterSettingForm
        )}
        updateModal={channelsMasterSettingSubmit(
          submitPmMasterUpdateSettingForm
        )}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_channelsMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="ChannelsTypeGeneralSettingChannelsForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="ChannelsTypeTypeName" class="required">
                  Select Channels Type
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][channel_id]"
                    class="required valid"
                    id="MasterSettingsChannelsTypeId"
                    {...channelsMasterSettingReg("channel_id")}
                    value={channelsMasterSettingInputForm?.channel_id}
                    onChange={(e) =>
                      changeChannelsMasterSettingInputHandler(
                        "channel_id",
                        e?.target?.value ?? ""
                      )
                    }
                  >
                    <option value="">Select</option>
                    {checkArray(master_setting_details?.channels?.channels) &&
                      master_setting_details?.channels?.channels.map(
                        (channelType) => {
                          return (
                            <option value={channelType?.id}>
                              {channelType.channel_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={channelsMasterSettingErrors}
                    name="channel_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.channels?.all_accounts
                    ) &&
                      master_setting_details?.channels?.all_accounts.map(
                        (groups) => {
                          return (
                            <Fragment key={groups?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`channels_group_id_${groups?.id}`}
                                onClick={() => accountClickHandler(groups)}
                                checked={checkAccountIsClicked(groups)}
                              />
                              <label for={`channels_group_id_${groups?.id}`}>
                                Group - {groups?.account_name ?? ""}
                              </label>

                              <a
                                class="link"
                                role="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`.channels-account-multi-collapse-${groups?.id}`}
                                aria-expanded="false"
                                aria-controls={`channels-account-collapse-${groups?.id}`}
                              >
                                {" "}
                                <i className="btn dropdown" />{" "}
                              </a>
                              <div
                                id={`channels-account-collapse-${groups?.id}`}
                                className={`group-collapse inner-checkbox collapse channels-account-multi-collapse-${groups?.id}`}
                              >
                                {checkArray(groups?.cluster) &&
                                  groups?.cluster
                                    .filter((p) => checkArray(p.stores))
                                    .map((cluster) => {
                                      return (
                                        <div class="groupSec">
                                          <div className="checkbox avaiCheck flex-wrap">
                                            <input
                                              type="checkbox"
                                              className="avail_checkbox"
                                              value={true}
                                              id={`channels_cluster_id_${cluster?.id}`}
                                              onClick={() =>
                                                clusterClickHandler(
                                                  groups?.id,
                                                  cluster
                                                )
                                              }
                                              checked={checkClusterIsClicked(
                                                cluster
                                              )}
                                            />
                                            <label
                                              for={`channels_cluster_id_${cluster?.id}`}
                                            >
                                              Cluster -{" "}
                                              {cluster?.cluster_name ?? ""}
                                            </label>
                                            {checkArray(cluster?.stores) && (
                                              <>
                                                <a
                                                  class="link"
                                                  role="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`.channels-cluster-multi-collapse-${cluster?.id}`}
                                                  aria-expanded="false"
                                                  aria-controls={`channels-cluster-collapse-${cluster?.id}`}
                                                >
                                                  {" "}
                                                  <i className="btn dropdown" />{" "}
                                                </a>
                                                <div
                                                  class={`pt-3 collapse inner-checkbox channels-cluster-multi-collapse-${cluster?.id}`}
                                                  id={`channels-cluster-collapse-${cluster?.id}`}
                                                >
                                                  {checkArray(
                                                    cluster?.stores
                                                  ) &&
                                                    cluster?.stores.map(
                                                      (store) => {
                                                        return (
                                                          <div className="checkbox avaiCheck">
                                                            <input
                                                              type="checkbox"
                                                              className="avail_checkbox"
                                                              value={true}
                                                              id={`channels_store_id_${store?.id}`}
                                                              onClick={() =>
                                                                storeClickHandler(
                                                                  groups?.id,
                                                                  store
                                                                )
                                                              }
                                                              checked={
                                                                accounts.findIndex(
                                                                  (p) =>
                                                                    p.store_merchant_id ==
                                                                    store.merchant_id
                                                                ) > -1
                                                              }
                                                            />
                                                            <label
                                                              for={`channels_store_id_${store?.id}`}
                                                            >
                                                              Store -{" "}
                                                              {store?.merchant
                                                                ?.account_name ??
                                                                ""}
                                                            </label>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                              </div>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
              <li>
                <label for="OrphanAccount" class="required">
                  <strong>Orphan</strong> - No Cluster
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.channels?.other_accounts
                    ) &&
                      master_setting_details?.channels?.other_accounts.map(
                        (other_account) => {
                          return (
                            <Fragment key={other_account?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`channels_other_account_id_${other_account?.id}`}
                                onClick={() =>
                                  otherAccountClickHandler(other_account)
                                }
                                checked={
                                  accounts.findIndex(
                                    (p) =>
                                      p.store_merchant_id == other_account.id
                                  ) > -1
                                }
                              />
                              <label
                                for={`channels_other_account_id_${other_account?.id}`}
                              >
                                Store - {other_account?.account_name ?? ""}
                              </label>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
      <ModelContainer
        title={`EDIT CHANNEL`}
        open={editChannelsMasterSettingModal}
        closeModal={closeEditChannelsMasterSettingModal}
        submitModal={editChannelsMasterSettingSubmit(
          submitEditChannelsMasterSettingForm
        )}
        updateModal={editChannelsMasterSettingSubmit(
          submitEditPmMasterUpdateSettingForm
        )}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_editChannelsMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="ChannelsTypeGeneralSettingChannelsForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          {console.log(
            "editChannelsMasterSettingErrors:",
            editChannelsMasterSettingErrors
          )}
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="ChannelsTypeTypeName" class="required">
                  Select Channel
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][channel_id]"
                    class="required valid"
                    id="MasterSettingsChannelsTypeId"
                    {...editChannelsMasterSettingReg("channel_id")}
                    value={editChannelsMasterSettingInputForm?.channel_id}
                    disabled
                  >
                    <option value="">Select Channel</option>
                    {checkArray(master_setting_details?.channels?.channels) &&
                      master_setting_details?.channels?.channels.map(
                        (channelType) => {
                          return (
                            <option value={channelType?.id}>
                              {channelType.channel_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={editChannelsMasterSettingErrors}
                    name="channel_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    <input
                      type="checkbox"
                      className="avail_checkbox"
                      value={0}
                      id={`edit_channels_group_id_${selectedChannelSetting?.id}`}
                      checked={true}
                      disabled={true}
                    />
                    <label
                      for={`edit_channels_group_id_${selectedChannelSetting?.id}`}
                    >
                      Group -{" "}
                      {selectedChannelSetting?.merchant?.account_name ?? ""}
                    </label>

                    <a
                      class="link"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`.channels-account-multi-collapse-${
                        selectedChannelSetting?.id ?? ""
                      }`}
                      aria-expanded="true"
                      aria-controls={`channels-account-collapse-${
                        selectedChannelSetting?.id ?? ""
                      }`}
                    >
                      {" "}
                      <i className="btn dropdown" />{" "}
                    </a>
                    <div
                      id={`channels-account-collapse-${
                        selectedChannelSetting?.id ?? ""
                      }`}
                      className={`group-collapse inner-checkbox channels-account-multi-collapse-${
                        selectedChannelSetting?.id ?? ""
                      }`}
                    >
                      <div class="groupSec">
                        <div className="checkbox avaiCheck flex-wrap">
                          <input
                            type="checkbox"
                            className="avail_checkbox"
                            value={true}
                            id={`channels_cluster_id_${
                              selectedChannelSetting?.cluster?.id ?? 0
                            }`}
                            checked={true}
                            disabled={true}
                          />
                          <label
                            for={`channels_cluster_id_${
                              selectedChannelSetting?.cluster?.id ?? 0
                            }`}
                          >
                            {selectedChannelSetting?.cluster?.cluster_name
                              ? `Cluster - ${selectedChannelSetting?.cluster?.cluster_name}`
                              : `Orphan - No Cluster`}
                          </label>
                          <a
                            class="link"
                            role="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`.channels-cluster-multi-collapse-${selectedChannelSetting?.cluster?.id}`}
                            aria-expanded="true"
                            aria-controls={`channels-cluster-collapse-${selectedChannelSetting?.cluster?.id}`}
                          >
                            {" "}
                            <i className="btn dropdown" />{" "}
                          </a>
                          <div
                            class={`pt-3 inner-checkbox channels-cluster-multi-collapse-${selectedChannelSetting?.cluster?.id}`}
                            id={`channels-cluster-collapse-${selectedChannelSetting?.cluster?.id}`}
                          >
                            <div className="checkbox avaiCheck">
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={true}
                                id={`store_id_${selectedChannelSetting?.store_merchant?.id}`}
                                checked={true}
                                disabled={true}
                              />
                              <label
                                for={`store_id_${selectedChannelSetting?.store_merchant?.id}`}
                              >
                                Store -{" "}
                                {selectedChannelSetting?.store_merchant
                                  ?.account_name ?? ""}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
    </div>
  );
};
export default Channels;
